<template>
    <!-- modal-xl -->
    <b-modal id="createRegulationModal" title="Create Regulation Modal" title-class="font-18" hide-footer>
        <b-overlay :show="show">
            <div class="textcenter">
                <!-- <h5 class="mb-3">{{ this.searchForm.company_name }}</h5> -->
                <b-form>
                    <b-form-group label="Title:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <b-form-input
                            v-model="$v.regulationForm.title.$model"
                            size="sm"
                            :state="validateState('title')"
                            aria-describedby="input-1-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            Required
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Start Date" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <!-- <b-form-datepicker v-model="value1" class="mb-2"></b-form-datepicker> -->
                        <b-form-input
                            id="date"
                            type="date"
                            size="sm"
                            v-model="$v.regulationForm.start_date.$model"
                            :state="validateState('start_date')"
                            aria-describedby="input-2-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                            Required
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        v-if="!this.regulationForm.is_current"
                        label="End Date"
                        label-cols-sm="3"
                        label-size="sm"
                        class="align-text-setting mr-5"
                    >
                        <!-- <b-form-datepicker v-model="value1" class="mb-2"></b-form-datepicker> -->
                        <b-form-input
                            id="date"
                            type="date"
                            size="sm"
                            v-model="$v.regulationForm.end_date.$model"
                            :state="validateState('end_date')"
                            aria-describedby="input-2-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                            Required
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <div class="align-text-setting-r mr-5 ml-4">
                        <b-form-checkbox @change="isActiveChanged" size="sm" id="checkbox-1" name="checkbox-1" class="mt-4 mb-2 ml-5" switch>
                            Set this Regulation as the current active one
                        </b-form-checkbox>
                    </div>
                </b-form>
            </div>

            <div class="modal-footer mt-3">
                <b-button @click="createRegulation" variant="primary" type="button" class="btn btn-primary">
                    Save
                </b-button>
                <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                    Close
                </b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import Swal from "sweetalert2";
//eslint-disable-next-line
import { required, helpers, minLength, maxLength, numeric, date } from "vuelidate/lib/validators";
//eslint-disable-next-line
import { certificateValidationComputed, certificateValidationMethods } from "../../../state/helpers";

export default {
    data: () => ({
        show: false,
        formSubmit: false,
        //values for the calendar
        regulationForm: {
            title: "",
            start_date: null,
            end_date: null,
            is_current: 0,
        },
    }),
    validations: {
        regulationForm: {
            title: { required, minLength: minLength(2) },
            start_date: {
                required,

                // minValue: helpers.withMessage("End date must be after today", (value) => {
                //     //eslint-disable-next-line
                //     console.log(value);
                //     return new Date(value) > new Date();
                // }),
            },
            end_date: {
                // required() {
                //     // Check if is_current is set to 1 (true)
                //     return this.regulationForm.is_current === 1;
                // },
                // minLength: minLength(2),
                // Add other validation rules for the end_date if needed
                required,
            },
        },
    },
    computed: {
        ...certificateValidationComputed,
    },
    methods: {
        ...certificateValidationMethods,
        isActiveChanged() {
            this.regulationForm.is_current = !this.regulationForm.is_current;
        },
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.regulationForm[name];
                return $dirty ? !$error : null;
            }
        },

        closeModal() {
            this.$bvModal.hide("createRegulationModal");
        },
        createRegulation() {
            this.formSubmit = true;

            if (
                this.$v.regulationForm.title.$anyError == false &&
                this.$v.regulationForm.start_date.$anyError == false &&
                this.regulationForm.is_current == 1
            ) {
                //delete on form
                delete this.$v.regulationForm.end_date;
            }

            if (
                this.$v.regulationForm.title.$anyError == false &&
                this.$v.regulationForm.start_date.$anyError == false &&
                this.regulationForm.is_current == 0
            ) {
                this.$v.regulationForm.$touch();
                if (this.$v.regulationForm.$anyError) {
                    return;
                }
            }
            this.show = true;

            //eslint-disable-next-line
            console.log(this.regulationForm.title, this.regulationForm.start_date, this.regulationForm.end_date);

            this.saveCreateRegulationVersion({
                name: this.regulationForm.title,
                start_date: this.regulationForm.start_date,
                end_date: this.regulationForm.end_date,
                is_current: this.regulationForm.is_current,
            }).then(() => {
                //eslint-disable-next-line
                console.log("created");
                this.setRegulationVersions();
                this.closeModal();
                this.show = false;
                Swal.fire(`Regulation Created`, "successfully", "");
            });
        },
    },
    mounted() {
        //eslint-disable-next-line
        console.log("createRegulationModal");
    },
};
</script>

<style lang="scss" scoped>
.align-text-setting {
    text-align: right;
}
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
}
</style>
